import { defineComponent as i, createElementBlock as l, openBlock as p, mergeProps as n, unref as e, renderSlot as d } from "vue";
import r from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Page/page.js";
import { classesFromBreakpointProps as m } from "../../breakpoints.js";
import { useOUIAProps as f } from "../../helpers/ouia.js";
const c = ["tabindex", "role"], v = /* @__PURE__ */ i({
  name: "PfPageGroup",
  __name: "PageGroup",
  props: {
    shadowTop: { type: Boolean },
    shadowBottom: { type: Boolean },
    overflowScroll: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean },
    sticky: {},
    stickySm: {},
    stickyMd: {},
    stickyLg: {},
    stickyXl: {},
    sticky2xl: {}
  },
  setup(t) {
    const s = t, a = f({ id: s.ouiaId, safe: s.ouiaSafe });
    return (o, u) => (p(), l("div", n(e(a), {
      class: [
        e(r).pageMainGroup,
        ...e(m)(o.$props, [
          "sticky"
        ], e(r), { vertical: !0 }),
        {
          [e(r).modifiers.shadowTop]: o.shadowTop,
          [e(r).modifiers.shadowBottom]: o.shadowBottom,
          [e(r).modifiers.overflowScroll]: o.overflowScroll
        }
      ],
      tabindex: o.overflowScroll ? 0 : void 0,
      role: o.overflowScroll ? "region" : void 0
    }), [
      d(o.$slots, "default")
    ], 16, c));
  }
});
export {
  v as default
};
